export function PersonalReminderRoutes($stateProvider: ng.ui.IStateProvider) {
  $stateProvider.state('my.newreminder', {
    url: 'new-reminder/',
    templateUrl: 'lib/create_personal_reminder/create_personal_reminder.html',
    controller: 'NewPersonalReminderController',
    controllerAs: '$ctrl',
    params: { personalTodoID: undefined },
    data: { viewTitle: 'Add your own personal to-do' }
  });
}



// WEBPACK FOOTER //
// ./app/lib/create_personal_reminder/reminder_routes.ts